export const ADMIN = 'admin'
export const DATASCIENTIST = 'dataScientist'
export const USER = 'user'
export const DEFAULT = 'default'

export default [ADMIN, DATASCIENTIST, USER]
